import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-display-single-rel',
  template: require('./display-single-rel.component.html'),
  styles: [require('./display-single-rel.component.scss')],
})
export class DisplaySingleRelComponent {
  @Input() field: string;
  @Input() displayKey: string;
  @Input() className: string;
  @Input() value: any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/display-single-rel/display-single-rel.component.ts